<template>
  <div id="app" ref="app">
    <app-header/>
    <breadcrumbs/>
    <transition
      v-on:enter="enter"
      v-on:leave="leave"
      v-on:afterLeave="afterLeave"
      :css="false"
      mode="out-in"
      >
      <router-view :key="$route.name" />
    </transition>
    <app-footer/>
  </div>
</template>
<script>
// https://medium.com/hypefactors/add-i18n-and-manage-translations-of-a-vue-js-powered-website-73b4511ca69c
// https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-vue-app-with-vue-i18n
import AppHeader from '@/components/AppHeader.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';
import AppFooter from '@/components/AppFooter.vue';
import BodyClasses from '@/include/bodyClasses';

// https://stackoverflow.com/questions/41572974/how-to-load-all-server-side-data-on-initial-vue-js-vue-router-load

export default {
  components: {
    AppHeader,
    Breadcrumbs,
    AppFooter
  },
  data(){
    return {
      // Transitions in ms
      transitionTime: 200
    }
  },

  mounted(){
    this.$refs.app.style.transition = `opacity ${this.transitionTime/1000}s`;
  },

  methods: {
    //   name="fade" 
    //   mode="out-in"
    enter(el, done){
      this.$refs.app.style.opacity = 1;
      setTimeout(() => {done();}, this.transitionTime);
    },
    leave(el, done) {
      this.$refs.app.style.opacity = 0;
      setTimeout(() => {
        done();
      }, this.transitionTime);
    },
    afterLeave: function (el) {
      BodyClasses.setClass('modal-active', false);
    },
  }
};

</script>
<style lang="scss">
  @import "@/assets/styles/core-classes.scss";
  #app {
    max-width: $global-width;
    margin: 0 auto;
    position: relative;
    min-height: 100vh;
    padding-bottom: 100px;
  }
</style>
